declare type ScrollPositionRestorationMode = 'disabled' | 'enabled' | 'top';

export const ScrollPositionRestorationMode: Record<
  ScrollPositionRestorationMode,
  ScrollPositionRestorationMode | undefined
> = {
  disabled: 'disabled',
  enabled: 'enabled',
  top: 'top'
};
